import React from 'react';
import { NEU_BG, NEU_RAISED, BORDER_SUBTLE, TEXT_PRIMARY, TEXT_FAINT, SURF_ALT, SURF_HOV } from '../theme';

const DataTable = ({ columns, data, onRowClick, getRowStyle }) => (
  <div style={{
    background: NEU_BG,
    borderRadius: 16,
    boxShadow: NEU_RAISED,
    border: `1px solid ${BORDER_SUBTLE}`,
    overflow: 'hidden',
  }}>
    <div style={{ overflowX: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ background: SURF_ALT, borderBottom: `1px solid ${BORDER_SUBTLE}` }}>
            {columns.map((col, i) => (
              <th key={i} style={{
                padding: '12px 16px',
                textAlign: col.align || 'right',
                color: TEXT_FAINT,
                fontSize: 10,
                fontWeight: 700,
                letterSpacing: 0.5,
                textTransform: 'uppercase',
                whiteSpace: 'nowrap',
              }}>
                {col.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIdx) => {
            const rowExtraStyle = getRowStyle ? getRowStyle(row) : undefined;
            const baseBackground = rowExtraStyle?.background || 'transparent';
            return (
            <tr
              key={rowIdx}
              onClick={() => onRowClick && onRowClick(row)}
              style={{
                borderBottom: `1px solid ${BORDER_SUBTLE}`,
                cursor: onRowClick ? 'pointer' : 'default',
                transition: 'background 0.1s',
                ...rowExtraStyle,
              }}
              onMouseEnter={e => { e.currentTarget.style.background = SURF_HOV; }}
              onMouseLeave={e => { e.currentTarget.style.background = baseBackground; }}
            >
              {columns.map((col, colIdx) => (
                <td key={colIdx} style={{
                  padding: '12px 16px',
                  textAlign: col.align || 'right',
                  fontSize: 13,
                  color: TEXT_PRIMARY,
                  whiteSpace: 'nowrap',
                }}>
                  {col.render ? col.render(row) : row[col.key]}
                </td>
              ))}
            </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  </div>
);

export default DataTable;
